// extracted by mini-css-extract-plugin
module.exports = {"toolboxBlocks":"WebAppSpeakup_toolboxBlocks__1aNZ_","toolboxText":"WebAppSpeakup_toolboxText__3gQih","button":"WebAppSpeakup_button__3VYmK"};